//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

import { makeStyles } from "@material-ui/core/styles";

export const styles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginBottom: 20,
  },
  tableDownInResponsive: {
    marginBottom: 150,
  },
  createBtn: {
    float: "right",
  },
  link: {
    color: "blue",
    textDecoration: "underline",
    cursor: "pointer",
  },
  // Create
  dateInput: {
    width: "100%",
  },
  submitBtn: {
    color: "#fff",
    backgroundColor: "#305698 !important",
    fontSize: 15,
    border: " 1px solid #2F7CBD",
    borderRadius: 10,
    textTransform: "capitalize",
    width: 100,
    "&:hover": {
      backgroundColor: "#305698 !important",
    },
  },
  // View
  label: {
    verticalAlign: "-webkit-baseline-middle",
  },
  editInput: {
    width: "80%",
  },
  cancelBtn: {
    color: "#305698",
    backgroundColor: "#fff !important",
    fontSize: 15,
    border: "1px solid #2F7CBD",
    borderRadius: 10,
    textTransform: "capitalize",
    width: 100,
    "&:hover": {
      backgroundColor: "#fff !important",
    },
  },
  // Dialog
  dialogParentDiv: {
    padding: 25,
  },
  parentText: {
    fontSize: 25,
  },
  exportBtn1: {
    color: "#fff",
    width: "120px",
    height: "35px",
    fontSize: "14px",
    cursor: "pointer",
    fontFamily: "segoe-ui",
    borderRadius: 5,
    backgroundColor: "#0a72ba",
    border: "none",
    // marginLeft:"38%",

    "@media (max-width: 600px)": {
      marginTop: "4rem",
    },
  },
  // CSVlink: {
  //   display: "none",
  // },
}));
